/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

export default {
  apiImageUrl: null,
  apiMaxDepth: 9,
  apiTypeDocs : {},
  apicPortalNewAppLink: null,
  apicPortalUserId: null,
  authentication: null,
  certificateStripNewlines: false,
  certificateStripPrefix: false,
  defaultLanguage: null,
  deferBootstrap: false,
  docsActive: false,
  enableToggleInteract: false,
  explorerDir: "/",
  removeIBMKeys: false,
  fixedCredentials: null,
  groupByTags: false,
  headerActive: false,
  headerTitle: "API Docs",
  infoSectionEntries: null,
  isApicPortal: false,
  languages: ["curl", "ruby", "python", "php", "java", "node", "go", "swift"],
  loggedIn: false,
  loginLink: null,
  nestedTags: false,
  onReady: null,
  optimiseOauthUX: false,
  renderSchemaView: false,
  showApiVersion: true,
  showAsyncApiDownload: true,
  showCorsWarnings: true,
  showInteract: true,
  showMTLSHeader: true,
  showSoapCodeSnippets: false,
  showSoapSwaggerDownload: false,
  showSwaggerDownload: true,
  tryIt: true,
  validateSwagger: true,
  routerType: 'memory',
  exampleArrayItems: 3
}
